import type { FeedbackMessages } from './en';

const zh: FeedbackMessages = {
  qualified: {
    title: '感谢您完成本次研究！',
    text: '您现在可以关闭浏览器窗口。\n\n我们期待很快再次见到您。',
  },
  quotaFull: {
    title: '本次研究已结束',
    text: '感谢您对我们研究的关注。\n\n很遗憾，我们已收到所需的全部回复。\n\n希望在我们未来的研究中能与您相见！',
  },
  terminated: {
    title: '感谢您分享您的反馈！',
    text: '我们期待在未来的研究中很快再次见到您。在此之前，祝您有美好的一天。\n\n请关闭此浏览器窗口。',
  },
  mismatch: {
    title: '感谢您的关注',
    text: '很遗憾，您不属于本次特定研究的目标群体。\n\n您可以关闭此页面。',
  },
  error: {
    title: '我们无法处理您的请求',
    linkProblemDetailed:
      '您所访问的链接出现问题。请检查地址栏中的链接是否与提供给您的链接一致，然后重试。',
    linkProblemGeneric: '您所访问的链接出现问题。请重试。',
    contactPerson: '如果问题持续存在，请告知向您提供该链接的人此问题。',
  },
};

export default zh;
